import { mapActions, mapState } from 'vuex'
import { formHandlerMixin } from '@/mixins/mixins'

let VueScrollTo = require('vue-scrollto')

const SCRIPT_ID = 'recaptchaScript'
const API_SRC = 'https://www.google.com/recaptcha/api.js' +
  '?onload=idunRenderRecaptcha&render=explicit'

// List this AFTER formHandlerMixin, which it depends on and whose
// showErrorMessage it overrides. Give the host a <div ref="recaptcha">
// inside id="captcha-container", call loadRecaptcha() from mounted() and
// destroyRecaptcha() from beforeDestroy(), and send captchaToken.
export default {
  data () {
    return {
      captchaToken: '',
      captchaWidgetId: null,
      captchaError: false,
      grecaptchaReady: false
    }
  },
  computed: {
    ...mapState({
      recaptcha: state => state.recaptchaModule.recaptcha
    })
  },
  methods: {
    ...mapActions([
      'setupRecaptcha'
    ]),
    loadRecaptcha () {
      return this.setupRecaptcha().then((config) => {
        if (!config.enabled) {
          return
        }
        window.idunRenderRecaptcha = this.onRecaptchaApiReady
        let script = document.createElement('script')
        script.setAttribute('id', SCRIPT_ID)
        script.setAttribute('async', '')
        script.setAttribute('defer', '')
        script.setAttribute('src', API_SRC)
        document.head.appendChild(script)
      }).catch(() => {
        // Leave it off and let the backend decide.
      })
    },
    onRecaptchaApiReady () {
      this.grecaptchaReady = true
      this.renderRecaptcha()
    },
    // The script and the host's own data race; the later one wins.
    renderRecaptcha () {
      if (!this.grecaptchaReady || this.captchaWidgetId !== null) {
        return
      }
      if (!this.$refs.recaptcha) {
        return
      }
      this.captchaWidgetId = window.grecaptcha.render(this.$refs.recaptcha, {
        sitekey: this.recaptcha.siteKey,
        callback: (token) => {
          this.captchaToken = token
          this.captchaError = false
        },
        'expired-callback': () => {
          this.captchaToken = ''
        }
      })
    },
    resetRecaptcha () {
      this.captchaToken = ''
      if (this.captchaWidgetId === null) {
        return
      }
      window.grecaptcha.reset(this.captchaWidgetId)
    },
    destroyRecaptcha () {
      let script = document.getElementById(SCRIPT_ID)
      if (script) {
        document.head.removeChild(script)
      }
      delete window.idunRenderRecaptcha
    },
    handleCaptchaRejection (err) {
      if (!err || !err.data || !err.data.captcha) {
        return false
      }
      this.captchaError = true
      this.resetRecaptcha()
      VueScrollTo.scrollTo('#captcha-container', 400, { offset: -100 })
      return true
    },
    // Replaces the mixin's method, so it delegates the rest back.
    showErrorMessage (err) {
      if (this.handleCaptchaRejection(err)) {
        return true
      }
      return formHandlerMixin.methods.showErrorMessage.call(this, err)
    }
  }
}
